import { render } from "./AppointmentsReportView.vue?vue&type=template&id=0e58a4c7&scoped=true"
import script from "./AppointmentsReportView.vue?vue&type=script&lang=js"
export * from "./AppointmentsReportView.vue?vue&type=script&lang=js"

import "./AppointmentsReportView.vue?vue&type=style&index=0&id=0e58a4c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e58a4c7"]])

export default __exports__